module.exports = __webpack_public_path__ + "img/title.9e8718f8.png";